import { render } from "./product-banner-area.vue?vue&type=template&id=7d65f71d&scoped=true"
import script from "./product-banner-area.vue?vue&type=script&lang=js"
export * from "./product-banner-area.vue?vue&type=script&lang=js"

import "./product-banner-area.vue?vue&type=style&index=0&id=7d65f71d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d65f71d"]])

export default __exports__